import { useCallback, useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { GTMEventData } from './GTMUtils';

export const useGTM: () => {
  gtmIsInitialized: boolean;
  initialiseDataLayer: (initEvent: GTMEventData) => void;
  updateDataLayer: <T>(eventBlock: GTMEventData<T>) => void;
} = () => {
  const [gtmIsInitialized, setGtmIsInitialized] = useState(false);
  const dataLayer = window.dataLayer;

  useEffect(() => {
    window.dataLayer ? setGtmIsInitialized(true) : setGtmIsInitialized(false);
  }, [dataLayer]);

  const initialiseDataLayer = (initEvent: GTMEventData): void => {
    if (window.dataLayer) return;

    console.log('initialising new dataLayer and starting TagManager');

    window.dataLayer = [];

    const tagManagerArgs = {
      gtmId: 'GTM-WM3B4P3',
    };

    TagManager.initialize(tagManagerArgs);

    updateDataLayer(initEvent);
  };

  const updateDataLayer: <T>(eventBlock: GTMEventData<T>) => void = useCallback(
    (eventBlock) => {
      if (!window.dataLayer) return;

      const finalEvent = {
        event: eventBlock.event,
        schema: eventBlock.schema,
        [eventBlock.schema]: { ...eventBlock.data },
      };

      window.dataLayer.push({ [eventBlock.schema]: null });
      window.dataLayer.push(finalEvent);
    },
    [],
  );

  return { gtmIsInitialized, initialiseDataLayer, updateDataLayer };
};
